import { useQuery } from "@apollo/client";
import { GET_ANALYTICS } from "/@/gql/analytics";
import { Title } from "@mantine/core";
import { AgCharts } from "ag-charts-react";

const AnalyticsPage = () => {
  const { data, loading, error } = useQuery(GET_ANALYTICS);

  if (loading) {
    return <>Loading...</>;
  }

  if (error) {
    return <>Error: {error.message}</>;
  }

  return (
    <>
      <Title>Order by week</Title>
      <AgCharts
        options={{
          data: data?.getAnalytics?.orderByWeek ?? [],
          series: [{ type: "bar", xKey: "week", yKey: "total" }],
        }}
      />
      <Title>Order by month</Title>
      <AgCharts
        options={{
          data: data?.getAnalytics?.orderByMonth ?? [],
          series: [{ type: "bar", xKey: "month", yKey: "total" }],
        }}
      />
    </>
  );
};

export default AnalyticsPage;
